import React from 'react';
import PropTypes from 'prop-types';

export default function SuccessParagraph({ children }) {
  return children ? <p className="paragraph">{children}</p> : null;
}
SuccessParagraph.propTypes = {
  children: PropTypes.any,
};
